import { SxProps, Theme } from '@mui/system';

const styles = {
  headerContainer: {
    paddingTop: 2,
    paddingLeft: 2,
  },
  title: {
    color: 'primary.main',
    fontSize: 26,
    fontWeight: '600',
  },
  caption: {
    fontSize: 14,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
